{
  "auth": {
    "requiredTitle": "შედით Telegram-ის მეშვეობით",
    "requiredBody": "გასაგრძელებლად გახსენით ეს აპი თქვენი Telegram ბოტიდან."
  },
  "navigation": {
    "back": "უკან",
    "home": "მთავარი",
    "profile": "პროფილი"
  },
  "dashboard": {
    "title": "სერვისები",
    "subtitle": "გასაგრძელებლად აირჩიეთ სერვისი",
    "loading": "სერვისები იტვირთება...",
    "noServices": "ამ ანგარიშში სერვისები ჩართული არ არის.",
    "queryServiceUnavailable": "მოთხოვნილი სერვისი ამ ანგარიშში ხელმისაწვდომი არ არის.",
    "communityLinks": "საზოგადოების ბმულები"
  },
  "services": {
    "ecommerce": {
      "title": "მაღაზია",
      "description": "პროდუქტების კატალოგი, შეკვეთები და მიწოდების სტატუსი."
    },
    "marketplace": {
      "title": "მარკეტფლეისი",
      "description": "განცხადებების ნახვა, გამოქვეყნება და ანონიმური კომუნიკაცია."
    },
    "events": {
      "title": "ივენთები",
      "description": "მიმდინარე ღონისძიებების სია და ლოკაციამდე მისვლის ინსტრუქციები."
    },
    "digitalMedia": {
      "title": "ციფრული მედიის მაღაზია",
      "description": "კურსები, აუდიო გამოცემები და გამოწერაზე დაფუძნებული სწავლა."
    },
    "healthBeauty": {
      "title": "ჯანმრთელობა და სილამაზე",
      "description": "კლინიკები, სალონები და სპეციალისტები — დაჯავშნეთ ვიზიტი"
    },
    "education": {
      "title": "განათლება",
      "description": "იპოვეთ დაწესებულებები, რეპეტიტორები და სანდო მიმოხილვები."
    },
    "restaurants": {
      "title": "რესტორნები",
      "description": "აღმოაჩინეთ რესტორნები, მენიუები და მაგიდის მოთხოვნები."
    }
  },
  "staff": {
    "title": "სტაფის ხელსაწყოები",
    "badge": "მართვა",
    "ecommerce": {
      "manager": {
        "title": "შეკვეთების მართვა",
        "description": "მართეთ შეკვეთები და მიტანები"
      }
    },
    "marketplace": {
      "moderator": {
        "title": "განცხადებების მოდერაცია",
        "description": "შეამოწმეთ და დაამოდერირეთ განცხადებები"
      }
    },
    "events": {
      "manager": {
        "title": "ივენთების მენეჯერი",
        "description": "მართეთ თქვენი ივენთები და ლოკაციები"
      }
    },
    "digitalMedia": {
      "manager": {
        "title": "Digital Media მენეჯერი",
        "description": "კურსებისა და გაკვეთილების მართვა"
      }
    },
    "healthBeauty": {
      "manager": {
        "title": "კლინიკის მიმღები",
        "description": "მართეთ დღევანდელი ჩანაწერები"
      }
    },
    "education": {
      "manager": {
        "title": "განათლების მენეჯერი",
        "description": "მართეთ განათლების მოთხოვნები და მიმოხილვები"
      }
    },
    "restaurants": {
      "manager": {
        "title": "რესტორნის მენეჯერი",
        "description": "მართეთ მენიუ, მაგიდის მოთხოვნები და შეფასებები"
      }
    }
  },
  "errors": {
    "loadServices": "სერვისების ჩატვირთვა ვერ მოხერხდა. სცადეთ ხელახლა."
  },
  "service": {
    "unavailable": "ეს სერვისი ამ ანგარიშში ხელმისაწვდომი არ არის."
  },
  "categories": {
    "marketplace": "მარკეტფლეისი",
    "petZone": "შინაური ცხოველები",
    "services": "სერვისები",
    "eventsBot": "ივენთების ბოტი",
    "shops": "მაღაზიები",
    "gifts": "საჩუქრები",
    "news": "სიახლეები",
    "rent": "ქირა",
    "digitalMedia": "ციფრული მედია",
    "healthBeauty": "ჯანმრთელობა და სილამაზე",
    "education": "განათლება",
    "restaurants": "რესტორნები",
    "title": "კატეგორიები"
  },
  "search": {
    "placeholder": "ძიება პლატფორმაზე…",
    "results": "ძიების შედეგები",
    "failed": "შედეგების ჩატვირთვა ვერ მოხერხდა. სცადეთ ხელახლა.",
    "empty": "შესაბამისი ჩანაწერები ვერ მოიძებნა"
  },
  "trending": {
    "title": "პოპულარული",
    "swipe": "გადაუსვით →",
    "item1": {
      "badge": "მნიშვნელოვანი",
      "title": "განცხადებების წესების განახლება"
    },
    "item2": {
      "badge": "ივენთები",
      "title": "IT-ის შეხვედრა ამ კვირა დღეს: რეგისტრაცია ღიაა"
    }
  },
  "partnership": {
    "title": "გახდით პარტნიორი",
    "subtitle": "დღესვე დაამატეთ თქვენი ბიზნესი ჩვენს პლატფორმაზე",
    "action": "მეტის ნახვა"
  },
  "footer": {
    "home": "მთავარი",
    "search": "ძიება",
    "favorites": "რჩეულები",
    "profile": "პროფილი"
  },
  "profile": {
    "description": "თქვენი ანგარიში ამ საზოგადოებაში.",
    "guest": "Telegram-ის მომხმარებელი"
  }
}
